module.exports = __webpack_public_path__ + "img/bg2.c9a34532.webp";